import { render, staticRenderFns } from "./VehicleAccessDetail.vue?vue&type=template&id=4993bc5d&scoped=true"
import script from "./VehicleAccessDetail.vue?vue&type=script&lang=js"
export * from "./VehicleAccessDetail.vue?vue&type=script&lang=js"
import style0 from "./VehicleAccessDetail.vue?vue&type=style&index=0&id=4993bc5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4993bc5d",
  null
  
)

export default component.exports